import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment-timezone';

import Avatar from './Avatar';

const getDate = (date) => {
  if (moment(date).isSame(moment(), 'day')) {
    return moment(date).format('h:mm A');
  }
  return moment(date).format('M/D/YYYY');
};

const Timeline = props => (
  <div className='timeline'>
    {(_.sortBy(props.finding.subEvents, e => e.date).reverse()).map((e, k) => (
      <div className='timeline-event' key={k}>
        <div
          className='row fill'
          style={{
            height: '100%',
            margin: '0px',
          }}
        >
          <div className='col-8'>
            <div className='date-wrapper'>
              <div className='date'>{getDate(e.date)}</div>
            </div>
            <div className='text-wrapper'>
              {e.value}
            </div>
          </div>
          <div className='col-4' style={{ textAlign: 'right' }}>
            <div className='user-wrapper'>
              <Avatar
                user={_.isObject(e.user) ? e.user : { firstname: 'System', lastname: 'Message' }}
              />
            </div>
          </div>
        </div>
      </div>
    ))}
    <div style={{ marginTop: '24px', textAlign: 'center' }}>
      Beginning of timeline
    </div>
  </div>
);

Timeline.propTypes = {
  finding: PropTypes.shape({ subEvents: PropTypes.array }),
};

Timeline.defaultProps = {
  finding: {
    subEvents: [],
  },
};

export default Timeline;



// WEBPACK FOOTER //
// ./src/views/Components/Timeline.js